import VSelect from 'vuetify/lib/components/VSelect';
import { ValidationProvider } from 'vee-validate';
import lazySelectMixin from '@/mixins/lazy-select-mixin';
import { CommercialityTypesSelectQuery } from './queries.gql';

export default {
  name: 'commercialities-select',

  mixins: [lazySelectMixin({ itemsKey: 'commercialities' })],

  props: {
    /** Explicación del Nuevo Componente commercialities-select
     * 
     * El questionConfig es el props que recibe las respuestas del cliente y el default simula las respuestas 
     * seleccionada del cliente a razon que no existe nada cargado aun,
     * en el caso que no exitan respuesta desde el props el default sera un Objecto vacio: default: []  
    */
    questionConfig: {type: Object, required: false, default: [ //queda pendiente modificar el required por TRUE y colocar el Props en el Componente en el appraisal-form.vue
        {
            id:'1',
            optionId:'5',
        },
    ]},
    /**
     * El questionCommercialities es el props que recibe las preguntas que se guardaron para ese Appraisal
     * y el default simula las unas preguntas ya existente seleccionada del cliente a razon que no existe nada cargado aun,
     * en el caso que no exitan preguntas anteriores significara que se trata una tasación nueva y el default sera un Objecto 
     * vacio: default: []  ya el tgis.questionCommercialities controlara si se cargan las preguntas del data.commercialities o el 
     * this.questionCommercialities, para evaluar la prueba debes borrar el arreglo dque contiene el default el props questionCommercialities
    */
    questionCommercialities: { type: Object, required: false, default: [ //queda pendiente modificar el required por TRUE y colocar el Props en el Componente en el appraisal-form.vue
        /*{
            "id": "1",
            "name": "1. Ejemplo Pregunta anteriores #1",
            "questions": [
            {
                "id": "5",
                "text": "¿Cuál es el nivel socioeconómico predominante en el entorno del inmueble?",
                "__typename": "CommercialityQuestionsType"
            }
            ],
            "__typename": "ComercialityAppraisalsType"
        },
        {
            "id": "4",
            "name": "2. Ejemplo Pregunta anteriores #2",
            "questions": [
            {
                "id": "6",
                "text": "¿Cuál es el estado de conservación del inmueble?",
                "__typename": "CommercialityQuestionsType"
            }
            ],
            "__typename": "ComercialityAppraisalsType"
        },
        {
            "id": "5",
            "name": "3. Ejemplo Pregunta anteriores #3",
            "questions": [
            {
                "id": "7",
                "text": "¿Cómo se compara el valor comercial del inmueble en relación con inmuebles similares en la zona?",
                "__typename": "CommercialityQuestionsType"
            }
            ],
            "__typename": "ComercialityAppraisalsType"
        },
        {
            "id": "6",
            "name": "4. Ejemplo Pregunta anteriores #4",
            "questions": [
            {
                "id": "8",
                "text": "¿Cuántos años tiene el inmueble, y cuál es su edad efectiva considerando remodelaciones o mejoras?",
                "__typename": "CommercialityQuestionsType"
            }
            ],
            "__typename": "ComercialityAppraisalsType"
        },
        {
            "id": "7",
            "name": "5. Ejemplo Pregunta anteriores #5",
            "questions": [
            {
                "id": "9",
                "text": "Ejemplo Pregunta anteriores #5",
                "__typename": "CommercialityQuestionsType"
            }
            ],
            "__typename": "ComercialityAppraisalsType"
        },
        {
            "id": "8",
            "name": "6. Ejemplo Pregunta anteriores #6",
            "questions": [
            {
                "id": "10",
                "text": "¿Qué tan completas y confiables son las conexiones de servicios básicos del inmueble (agua, electricidad y alcantarillado)?",
                "__typename": "CommercialityQuestionsType"
            }
            ],
            "__typename": "ComercialityAppraisalsType"
        },
        {
            "id": "9",
            "name": "7. Ejemplo Pregunta anteriores #7",
            "questions": [
            {
                "id": "11",
                "text": "¿Qué tan cerca está el inmueble de áreas de actividad económica (centros comerciales, oficinas, mercados, bancos)?",
                "__typename": "CommercialityQuestionsType"
            }
            ],
            "__typename": "ComercialityAppraisalsType"
        },
        {
            "id": "10",
            "name": "8. Ejemplo Pregunta anteriores #8",
            "questions": [
            {
                "id": "12",
                "text": "¿Cuál es la zonificación del inmueble?",
                "__typename": "CommercialityQuestionsType"
            }
            ],
            "__typename": "ComercialityAppraisalsType"
        },
        {
            "id": "11",
            "name": "9. Ejemplo Pregunta anteriores #9",
            "questions": [
            {
                "id": "13",
                "text": "¿Cuál es la tendencia de desarrollo en la zona donde se encuentra el inmueble?",
                "__typename": "CommercialityQuestionsType"
            }
            ],
            "__typename": "ComercialityAppraisalsType"
        },
        {
            "id": "12",
            "name": "10. Ejemplo Pregunta anteriores #10",
            "questions": [
            {
                "id": "14",
                "text": "¿Cómo ha sido la evolución de los precios inmobiliarios en los últimos 2 años en la zona?",
                "__typename": "CommercialityQuestionsType"
            }
            ],
            "__typename": "ComercialityAppraisalsType"
        },
        {
            "id": "13",
            "name": "11. Ejemplo Pregunta anteriores #11",
            "questions": [
            {
                "id": "15",
                "text": "¿Cuánto tiempo suelen estar en el mercado los inmuebles similares antes de venderse?",
                "__typename": "CommercialityQuestionsType"
            }
            ],
            "__typename": "ComercialityAppraisalsType"
        }*/    
    ]},
    itemValue: { type: String, default: 'id' },
    itemText: { type: String, default: 'text' },
    errorMessages: { type: Array, default: () => [] },
  },

  data() {
      return {
          commercialities: [],
          QuestionProperty: [],
          responseQuestions: this.questionConfig.filter( item => item.option !== "DEMANDA" ) || [],
          responses:[],
      };
  },

  methods: {
    initializeQuestions() {

        // Valida que exista información
        if (!this.commercialities.length > 0) return ;

        // Array con todos los IDs de preguntas que tenemos en el formulario
        const questionIds = this.commercialities;
  
        // Si tenemos datos previos del appraisal (en caso de edición)
        if (this.questionConfig.length > 0) {
            this.QuestionProperty = questionIds.map( items => ({
                questionId:parseInt(items.id),
                selectedOptionId:parseInt(this.getInitialResponse(items.id)),           
            }))
        } else {
          // Si es un nuevo formulario, inicializamos con valores por defecto
          this.QuestionProperty = questionIds.map(id => ({
            questionId: parseInt(id),
            selectedOptionId: 0 // o null, dependiendo de tu lógica de negocio
          }));
        }
  
        // eslint-disable-next-line no-console
        console.log( 'Estado inicial:', JSON.stringify(this.QuestionProperty) );
  
        // queda pendiente emitir los datos
        this.responses = this.QuestionProperty;

        // Emite el evento al componente padre si es necesario
        this.$emit('change', this.responses );
    },

    handleChange(questionId, selectedOption) {
        const 
            qId = parseInt(questionId),
            optionId = parseInt(selectedOption),
            existingIndex = this.QuestionProperty.findIndex( item => item.questionId === qId)
        ;

        if (existingIndex !== -1) {
            // Actualizamos la respuesta existente
            this.QuestionProperty[existingIndex].selectedOptionId = optionId;
        } else {
            // Agregamos nueva respuesta si no existe
            this.QuestionProperty.push({
                questionId: qId,
                selectedOptionId: optionId
            });
        }

        // Actualizamos el data principal para el submit
        this.responses = [...this.QuestionProperty];

        // Emite el evento al componente padre si es necesario
        this.$emit('change', this.responses );
    },
  },

  computed: {
    questions() {
        return (questionID) => {
            const selectedQuestion = this.commercialities.find( item => item.id === questionID.toString() );

            if(!selectedQuestion) return;
            return selectedQuestion.name;
        };
    },

    response() {
        return (questionID) => {
            const selectedResponse = this.commercialities.find( item => item.id === questionID.toString() );

            if(!selectedResponse) return;
            return selectedResponse.questions;
        };
    },

    formattedItems() {
        return (questionID) => {
            return this.response(questionID).map( item => ({
                id:item.id,
                text:item.text,
            }));
        };    
    },
    
    getInitialResponse() {
        return (questionId) => {
            if (!this.responseQuestions.length > 0) {
                return '0';
            }
            const matchingItem = this.responseQuestions.find( item => item.id === questionId.toString() );

            if (matchingItem) {
                return matchingItem.optionId.toString();
            } else {
                return '0';
            }
        }
    },
  },

  mounted() {
    this.initializeQuestions();
  },

  watch:{
    commercialities: {
        handler() {
            this.initializeQuestions();
        },
        deep: true
    },
  },

  apollo: {
    commercialities: {
        query: CommercialityTypesSelectQuery,
        result({ data }) {
            /**
             * En este IF valida si se cargan las preguntas del commercialities en caso que no existan preguntas en el 
             * questionCommercialities y en el caso contrario carga las preguntas del questionCommercialities.
            */
            if (data && data.commercialities && !this.questionCommercialities.length > 0) {
                this.commercialities = data.commercialities.filter(item => item.name !== 'Demanda');
            } else {
                this.commercialities = this.questionCommercialities;
            }
        },
    }     
  },

    render(h) {
        return h('div', {
            // Estas son clases de Vuetify para flexbox
            staticClass: 'd-flex flex-wrap',
            style: {
                // Compensar el padding de los elementos hijos
                margin: '-8px', 
            }
        }, [
            this.commercialities.map(items =>
                h('div', {
                    key: items.id,
                    // Padding alrededor de cada elemento
                    staticClass: 'pa-2', 
                    style: {
                        // Cada elemento ocupa el 50% del ancho (2 por fila)
                        flexBasis: '50%', 
                        maxWidth: '50%',
                    }
                }, [
                    h(ValidationProvider, {
                        props: {
                            name: `commerciality-${items.id}`,
                            rules: 'required'
                        },
                        scopedSlots: {
                            default: (validation) =>
                                h(VSelect, {
                                    props: {
                                        value: this.getInitialResponse(items.id),
                                        items: this.formattedItems(items.id),
                                        label: this.questions(items.id),
                                        itemValue: this.itemValue,
                                        itemText: this.itemText,
                                        errorMessages: [...this.errorMessages, ...validation.errors],
                                        loading: this.$apollo.queries.commercialities.loading,
                                    },
                                    on: {
                                        input: (value) => {
                                            this.$emit('input', value);
                                            validation.validate(value);
                                        },
                                        change: (value) => this.handleChange(items.id, value)
                                    }
                                }
                            )
                        }
                    })
                ])
            )
        ]); 
    },
};